// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class CancelOrderMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_CANCEL_ORDER_MESSAGE, fieldSet);
    }
    getOrderId() {
        return this.getFieldValue(FieldsFactory.FIELD_ORDER_ID);
    }
    setOrderId(orderId) {
        this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId);
    }
    getOnBehalfId() {
        return this.getFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID);
    }
    setOnBehalfId(onBehalfId) {
        this.setFieldValue(FieldsFactory.FIELD_ON_BEHALF_USER_ID, onBehalfId);
    }
    getAccountId() {
        return this.getFieldValue(FieldsFactory.FIELD_ACCOUNT_ID);
    }
    setAccountId(id) {
        this.setFieldValue(FieldsFactory.FIELD_ACCOUNT_ID, id);
    }
    getInstrumentId() {
        return this.getFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID);
    }
    setInstrumentId(id) {
        this.setFieldValue(FieldsFactory.FIELD_INSTRUMENT_ID, id);
    }
    getInstrumentTradableID() {
        return this.getFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID);
    }
    setInstrumentTradableID(id) {
        this.setFieldValue(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, id);
    }
    setIsBrokerRequest(broker) {
        this.setFieldValue(FieldsFactory.FIELD_IS_BY_BROKER, broker);
    }
    setPlacedFrom(placedFrom) {
        this.setFieldValue(FieldsFactory.FIELD_CLIENT_PANEL, placedFrom);
    }
}
